import LegalPage from "../../components/LegalPage/LegalPage";

const sections = [
  {
    heading: "Information We Collect",
    items: [
      "Account details such as your name, email address, phone number, and saved addresses.",
      "Order, subscription, and support history connected to your account.",
      "Basic analytics and device information used to improve site performance and fraud protection.",
    ],
  },
  {
    heading: "How We Use Information",
    paragraphs: [
      "We use your information to process orders, personalize your account, respond to support requests, and improve the customer experience.",
      "We may also use limited contact details to send service messages related to your orders, subscriptions, or account security.",
    ],
  },
  {
    heading: "Sharing",
    paragraphs: [
      "We only share information with service providers that help us operate payments, fulfillment, support, analytics, and infrastructure.",
      "We do not sell your personal information.",
    ],
  },
  {
    heading: "Your Choices",
    items: [
      "Update profile and address details from your account dashboard.",
      "Contact support if you need help with account data corrections or deletion requests.",
      "Use your device or browser controls to manage cookies and similar technologies.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Privacy Policy"
      intro="This policy explains what information Chill Tree collects, how it is used, and the choices available to you."
      lastUpdated="April 14, 2026"
      sections={sections}
    />
  );
}




